import * as React from "react";
import type { SVGProps } from "react";
const SvgLogoSymbol = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={29}
    height={35}
    fill="none"
    viewBox="0 0 419 501"
    {...props}
  >
    <path
      fill="url(#logo-symbol_svg__a)"
      d="M5.155 500.629h13.998c22.51 0 42.892-9.127 57.646-23.881 14.802-14.755 23.882-35.137 23.882-57.647v-76.515c0-13.573 6.479-25.679 16.551-33.34a4.684 4.684 0 0 0 2.128-3.925 4.66 4.66 0 0 0-4.681-4.682h-13.998c-22.51 0-42.892 9.08-57.647 23.835-14.754 14.801-23.881 35.183-23.881 57.694v76.468c0 13.619-6.526 25.773-16.6 33.434a1 1 0 0 1-.283.189c-1.087.898-1.797 2.222-1.797 3.688 0 2.601 2.128 4.682 4.682 4.682"
    />
    <path
      fill="url(#logo-symbol_svg__b)"
      d="M104.983 500.633h13.998c22.51 0 42.892-9.127 57.646-23.882 14.802-14.754 23.882-35.136 23.882-57.646V242.571c0-13.572 6.479-25.679 16.551-33.34a4.69 4.69 0 0 0 2.129-3.925 4.66 4.66 0 0 0-4.682-4.681h-13.998c-22.51 0-42.892 9.079-57.647 23.834-14.754 14.802-23.881 35.184-23.881 57.694v176.486c0 13.62-6.526 25.773-16.599 33.434-.094.095-.189.142-.284.189-1.087.899-1.797 2.223-1.797 3.689 0 2.601 2.128 4.682 4.682 4.682"
    />
    <path
      fill="url(#logo-symbol_svg__c)"
      d="M204.719 500.63h13.998c22.51 0 42.892-9.127 57.647-23.881 14.802-14.755 23.881-35.137 23.881-57.647V142.55c0-13.572 6.479-25.679 16.552-33.34a4.7 4.7 0 0 0 2.128-3.925 4.663 4.663 0 0 0-4.682-4.682h-13.998c-22.51 0-42.892 9.08-57.646 23.835-14.755 14.801-23.882 35.183-23.882 57.694v276.505c0 13.619-6.526 25.773-16.599 33.434a1 1 0 0 1-.283.189c-1.088.898-1.797 2.222-1.797 3.688 0 2.601 2.128 4.682 4.681 4.682"
    />
    <path
      fill="url(#logo-symbol_svg__d)"
      d="M304.5 500.631h13.997c22.51 0 42.892-9.127 57.647-23.882 14.802-14.754 23.881-35.136 23.881-57.646V42.579c0-13.572 6.479-25.678 16.552-33.34a4.686 4.686 0 0 0 2.128-3.925 4.66 4.66 0 0 0-4.682-4.681h-13.998c-22.51 0-42.892 9.08-57.646 23.834-14.755 14.802-23.882 35.184-23.882 57.694v376.476c0 13.62-6.526 25.773-16.598 33.434-.095.095-.19.142-.284.189-1.088.899-1.797 2.223-1.797 3.689 0 2.601 2.128 4.682 4.682 4.682"
    />
    <defs>
      <linearGradient
        id="logo-symbol_svg__a"
        x1={-61.745}
        x2={672.495}
        y1={577.943}
        y2={146.328}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.15} stopColor="#0ACDA7" />
        <stop offset={0.85} stopColor="#0F53F2" />
      </linearGradient>
      <linearGradient
        id="logo-symbol_svg__b"
        x1={-61.745}
        x2={672.495}
        y1={577.943}
        y2={146.328}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.15} stopColor="#0ACDA7" />
        <stop offset={0.85} stopColor="#0F53F2" />
      </linearGradient>
      <linearGradient
        id="logo-symbol_svg__c"
        x1={-61.745}
        x2={672.495}
        y1={577.943}
        y2={146.328}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.15} stopColor="#0ACDA7" />
        <stop offset={0.85} stopColor="#0F53F2" />
      </linearGradient>
      <linearGradient
        id="logo-symbol_svg__d"
        x1={-61.745}
        x2={672.495}
        y1={577.943}
        y2={146.328}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.15} stopColor="#0ACDA7" />
        <stop offset={0.85} stopColor="#0F53F2" />
      </linearGradient>
    </defs>
  </svg>
);
export default SvgLogoSymbol;
